/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

/**
 * This directive allows the specification of exactly what portion of a content block is selectable content, and upon
 * which other directives, such as resize, operate.
 */
angular.module('bulbApp.contentEditorModule')

.directive('blockContent', blockContent);

function blockContent() {
  return {
    require: '^contentBlock',
    compile: function () {
      return {
        pre: function(scope, elem, attrs, contentBlockCtrl) {
          /**
           * This needs to be run in the pre-compile so that the frame element is available
           * in the other directive's linking functions.
           */
          contentBlockCtrl.contentElement = elem;
        }
      };
    }
  };
}
